import { EnqueteWelcome } from "../EnqueteCommon";

export function EnqueteServiceWelcome(props) {
  return <EnqueteWelcome {...props} pathPrefix="/services/enquetes" />;
}
